// extracted by mini-css-extract-plugin
module.exports = {"sixty":"Column_sixty__1d4RJ","fourty":"Column_fourty__2ZRRh"};